// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TLP-","newExpiryDate":"styles_newExpiryDate__2bDKZ","footer":"styles_footer__3OnSP"};